import {User, UserInterface} from "../users/api.models";
import {PermissionInterface} from "../permissions/api.models";
import {RoleInterface} from "../roles/api.models";

interface MeInterface extends UserInterface {
    role: MeRoleInterface;
}

interface MeRoleInterface extends RoleInterface {
    permissions: PermissionInterface[];
}

class Me extends User implements MeInterface{
    role: MeRoleInterface;
}

export {
    Me
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/me/me.models.ts